export enum AddProductModalTypeEnum {
  VARIANT = 'variant',
  PRODUCT = 'product',
  NEW_PRODUCT = 'newProduct',
}
